import { formatSilence, formatLastAnswer } from '../../helpers/measurementSignals/describeSignal'

// AI-CONTEXT: See docs/features/meetmoment-signalering.md

/**
 * Eén meetmoment van één anoniem onderzoek, als vakje in de matrix van de kaart
 * 'Anonieme onderzoeken'.
 *
 * Er staat een AANTAL in, geen vinkje. Bij een groepsmeting is er geen persoon
 * om af te vinken; hoe vaak de vragenlijst is ingevuld is het enige dat te
 * weten valt. Groen betekent dat er invullingen zijn, rood dat het er nul zijn —
 * en het getal zelf draagt dat verschil ook zonder kleur.
 *
 * Het getal telt INVULLINGEN, geen documenten: één ingevulde vragenlijst
 * schrijft een document per vraag én per matrixrij, dus documenten tellen geeft
 * een veelvoud van wat er werkelijk binnenkwam.
 * AI-CONTEXT: See docs/pitfalls.md#database-totaldocs-overcounts-respondents
 *
 * Onder een gevuld vakje staat wanneer het laatste antwoord binnenkwam. Onder
 * het eerste lege vakje staat hoe lang het al stil is. Geen aftelling naar een
 * datum: zonder deelnemer is er geen startpunt, dus geen termijn, en een
 * verzonnen termijn is erger dan geen termijn.
 *
 * @param {object} props
 * @param {{ID: string, Title?: string, submissions: number, lastAnswerMs: number|null}|null} [props.moment]
 *   Het meetmoment op deze positie; `null` als dit onderzoek er minder heeft
 * @param {boolean} [props.isNext] - Of dit het eerste meetmoment zonder invullingen is
 * @param {number|null} [props.silentDays] - Hoe lang er al niets binnenkwam; `null` = nog nooit iets
 * @param {number} [props.now] - Nu, in milliseconden
 */
const AnonymousMomentCell = ({ moment, isNext = false, silentDays = null, now }) => {
    if (!moment) return null

    const hasAnswers = moment.submissions > 0
    const label = hasAnswers
        ? `${moment.submissions} keer ingevuld`
        : 'nog niet ingevuld'

    const lastAnswer = hasAnswers ? formatLastAnswer(moment.lastAnswerMs, now) : ''

    return (
        <span className='moment-matrix-cell'>
            <span
                className={[
                    'moment-matrix-dot',
                    'moment-matrix-dot--number',
                    hasAnswers ? 'moment-matrix-dot--answers' : 'moment-matrix-dot--none',
                    isNext ? 'moment-matrix-dot--next' : '',
                ].filter(Boolean).join(' ')}
                title={`${moment.Title || 'Meetmoment'}: ${label}`}
            >
                {moment.submissions}
            </span>
            {lastAnswer && <span className='measurement-signal-note'>{lastAnswer}</span>}
            {!hasAnswers && isNext && (
                <span className='measurement-signal-note'>{formatSilence(silentDays)}</span>
            )}
        </span>
    )
}

export default AnonymousMomentCell
